import {collectQueryParams} from '@/utils/queryParams';
import {useMutation} from '@apollo/client';
import {TRACK_REFERRAL_LINK_CLICK} from './ReferralLink.queries';

export const shareBodyMessage = `Hey - we just signed up for this new reading app called Ello. You can sign up with this link and get your first month free if you want to try it out:`;

async function copyLinkToClipboard(link: string): Promise<boolean> {
  try {
    if (!navigator?.clipboard) {
      return false;
    }

    await navigator.clipboard.writeText(link);
    return true;
  } catch (e) {
    console.error('failed to copy to clipboard', e);
    return false;
  }
}

function referralLink(baseUrl?: string): string | undefined {
  const params = collectQueryParams() as {referralCode?: string; flow?: string};
  if (!params.referralCode) {
    return;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  let path = '/rof/';

  if (
    /iphone/.test(userAgent) &&
    params?.flow == 'inappPostSignup-mobile-referrals'
  ) {
    path = '/rih/';
  } else if (
    /ipad/.test(userAgent) &&
    params?.flow == 'inappPostSignup-referrals'
  ) {
    path = '/ria/';
  }

  const base = baseUrl || 'https://ello.com';

  return `${base}${path}${params.referralCode}`;
}

const useTrackReferralLinkClick = () => {
  const [trackReferralLinkClick] = useMutation(TRACK_REFERRAL_LINK_CLICK);

  const trackReferral = async (referralCode?: string) => {
    if (!referralCode) {
      return;
    }
    return trackReferralLinkClick({
      variables: {referralCode},
    });
  };

  return {trackReferral};
};

export const ReferralLinkService = {
  copyLinkToClipboard,
  referralLink,
  useTrackReferralLinkClick,
};
